import React from "react";
import { Outlet } from "react-router-dom";
import AuthFooter from "layouts/AuthFooter";

const PageAuth = () => {
    return (
        <React.Fragment>
            <Outlet />
            <AuthFooter />
        </React.Fragment>
    );
}

export default PageAuth;